module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "generalPage"
  }, [_c('div', {
    staticClass: "isotopeGrid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section2"
  }, [_c('div', {
    staticClass: "generalWrapper"
  }, [_c('div', {
    staticClass: "tab tabChannel"
  }, [_c('div', {
    staticClass: "tabTitle"
  }, [_vm._v("\n            威滅產品於下列商戶有售\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_grid 2init_4"
  }, [_c('div', {
    staticClass: "shoplist_table_rowgroup header"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('a', {
    staticClass: "product_img",
    on: {
      "click": function($event) {
        _vm.jumpToCockroach(1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/productCockroach-section3-product-1.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("速效曱甴藥餌")])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('router-link', {
    staticClass: "product_img",
    attrs: {
      "to": "/product/ant"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/productAnt-section2-overlay-nobadge.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("速效殺蟻藥餌")])], 1), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('router-link', {
    staticClass: "product_img",
    attrs: {
      "to": "/product/cockroach"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/productCockroach-section2-1.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("速效曱甴藥餌"), _c('nobr', [_vm._v("(典雅版)")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  }, [_c('a', {
    staticClass: "product_img",
    on: {
      "click": function($event) {
        _vm.jumpToCockroach(2)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/productCockroach-sectionGel-product.png")
    }
  })]), _vm._v(" "), _c('p', [_vm._v("專業強效曱甴"), _c('nobr', [_vm._v("凝膠餌劑")])], 1)])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15)])])])])]), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title_wrapper"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          銷售地點\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("\n          威滅產品銷售地點\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_welcome"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("惠康超級市場")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('a', {
    attrs: {
      "href": "https://www.wellcome.com.hk/zh-hant/our-store",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/welcome.jpg")
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_parknshop"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("百佳超級市場")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/parkinShop.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.pns.hk/zh-hk/all-brands/b/103679/%E5%A8%81%E6%BB%85",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_vanguard"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("華潤萬家*")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/vanguard.jpg")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_uselect"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("U-Select*")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/uselect.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_aeon"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("AEON")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/aeon.jpg")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.aeoncity.com.hk/kh_zh/non-food/householdgoods/003052610.html",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_yata"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("一田 YATA")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/yata.jpg")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_unyapita"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("UNY / APITA")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/apita.jpg")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_bamboos"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("百本旺角市集")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/bamboos.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_hktvmall"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("HKTV mall")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/hktvMall.jpg")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.hktvmall.com/hktv/zh/main/search?page=0&q=%3Arelevance%3Acategory%3AAA11824000001%3Azone%3Asupermarket%3Abrand%3ACombat%3Astreet%3Amain%3A",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_ztore"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("Ztore 士多")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/ztore.jpg")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.ztore.com/tc/search/combat",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_pandamart"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("PandaMart")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/pandamart.jpg")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.foodpanda.hk/groceries#all-pandamarts",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_homeplus"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("HOMEPLUS")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/homeplus.jpg")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.home-plus.hk/tc_hk/products?brand=17504",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_healthstore"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("HealthStore")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/healthstore.jpg")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.healthstore.com.hk/collections/combat-威滅?utm_source=combat&utm_medium=referral&utm_campaign=brandsite",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_rowgroup data shop_pharmacy"
  }, [_c('div', {
    staticClass: "shoplist_table_row"
  }, [_c('div', {
    staticClass: "shoplist_table_rowheader"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("各大藥行藥房")]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/all_pharmacy.jpg")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://docs.google.com/spreadsheets/d/1038226dN2l4fc_kwaJjAP6E5yiUBQNLo/edit?usp=sharing&ouid=109814576360705695639&rtpof=true&sd=true",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/btn-pharmacylist.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_1"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_2"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_3"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shoplist_table_column column_4"
  }, [_c('img', {
    staticClass: "icon-done",
    attrs: {
      "src": require("../assets/icon-done.svg")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplist_table_notice"
  }, [_c('p', [_vm._v("*部分產品只限指定門市有售貨")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c865c40","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Shoplist.vue
// module id = 234
// module chunks = 0